import React from "react";
import "./gaming.css";
import Button from "../../_components/button/Button";
import SlideOver from "../../_components/slide_over/SlideOver";
const Gaming = () => {
  const [showSlideOver, setSlideOver] = React.useState(false);

  const handleClick = () => {
    setSlideOver(true);
  };
  const title = (
    <h4 className="text-4xl md:text-5xl lg:text-6xl font-bold text-center lg:text-left  text-white leading-snug ">
      Experience Gaming Like Never Before on AVM 90
    </h4>
  );

  const Content = () => {
    return (
      <div className="px-4 pt-5 pb-5 sm:px-0 sm:pt-0">
        <dl className="space-y-8 px-4 sm:px-6 sm:space-y-6">
          <p className="text-sm lg:text-md">
            Supporting the next generation of audio and video formats, the AVM90
            unlocks the potential of the latest generation hardware. Immerse
            yourself with stunning resolution up to 8K/60Hz (4K/120Hz) and the
            latest generation audio formats in up to 19-channels (15.4).
            Experience every sight and sound, as the AVM 90 immerses you like
            never before. Advanced processing precisely positions every sound
            and renders it with breathtaking realism and clarity making it
            easier to get fully immersed in the game world and get an advantage
            over the competition. For those that demand nothing but the best,
            the AVM 90 is here.
          </p>

          <p className="text-sm lg:text-md">
            With up to 40Gbps bandwidth available on each of its 7 HDMI inputs,
            features like 4K/120Hz HDR graphics, Dolby Vision, and Dolby Atmos
            have never been easier to experience. AVM 90’s Variable Refresh Rate
            (VRR) support includes both Freesync and G-Sync, so whether you are
            a console or PC gamer you can experience high frame rate gaming with
            no screen tearing. In addition, AVM 90’s true HDMI 2.1 functionality
            means you won’t be locked out of any of the other current
            technologies made possible with next-generation consoles like the
            PlayStation 5 and Xbox Series X. Coupled with support for advanced
            features like Auto Low Latency Mode (ALLM) and HGiG, the AVM 90 is
            ready and waiting as these technologies roll out to your next-gen
            gaming hardware.
          </p>

          <p className="text-sm lg:text-md">
            For both today and tomorrow, the AVM 90 defines state-of-the-art
            gaming performance.
          </p>

          <p className="text-sm lg:text-md">
            Some features not currently supported on all consoles.
          </p>
        </dl>
      </div>
    );
  };
  return (
    <section className="z-50 relative" id="gaming">
      <SlideOver
        open={showSlideOver}
        setOpen={setSlideOver}
        title={"Experience Gaming Like Never Before on AVM 90"}
        content={<Content />}
      />
      <div
        className="bg-black  py-12 px-6 md:py-20 bg-no-repeat bg-cover	bg-center"
        style={{
          backgroundImage:
            "url(" +
            "https://cdn.pmlsound.com/anthem/avm90/images/avm90_gaming_web.jpg" +
            ")",
        }}
      >
        <div className="max-w-7xl mx-auto text-white  md:text-gray-900">
          <div className="visible lg:invisible lg:mb-0 mb-10 lg:h-0 h-auto">
            {title}
          </div>
          <div class="lg:flex gap-5">
            <div className="w-full lg:w-3/5 ">
              <video
                id="video"
                width="100%"
                autoPlay
                loop
                muted
                playsInline
                className="lg:mb-10"
              >
                <source
                  src="https://cdn.pmlsound.com/anthem/avm90/videos/avm90-gaming-webb_.mp4"
                  type="video/mp4"
                />
              </video>
            </div>
            <div className="w-full lg:w-2/5 ">
              <div className="invisible lg:visible lg:h-auto h-10">{title}</div>
              <p className="text-white mb-16 text-xl font-light lg:mt-10 lg:text-left text-center">
                It’s never been a more exciting time to be a gamer. With the
                latest consoles offering up to 4K/120Hz graphics, realistic HDR
                and Dolby Vision dynamic range, and immersive Dolby Atmos sound,
                you have to make sure your Home Theater gear won’t hold you
                back. Enter the AVM 90, our most feature-rich AV processor to
                date!
              </p>
              <Button name="Learn More" handleClick={handleClick} />
            </div>
          </div>
          {/* <div className="lg:h-32"></div> */}
        </div>
      </div>
    </section>
  );
};

export default Gaming;
